import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) return toast.error("సరైన ఇమెయిల్ నమోదు చేయండి");
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e) { toast.error("లోపం జరిగింది. మళ్ళీ ప్రయత్నించండి."); } finally { setBusy(false); }
  };

  return (
    <div className="parchment-texture min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-surface rounded-2xl temple-shadow gold-border p-6 sm:p-8 font-telugu" data-testid="forgot-page">
        <h1 className="font-display text-2xl font-extrabold text-maroon text-center mb-2">పాస్‌వర్డ్ మర్చిపోయారా?</h1>
        {sent ? (
          <div className="text-center space-y-3" data-testid="forgot-sent">
            <MailCheck className="w-12 h-12 text-saffron mx-auto" />
            <p className="text-maroon text-sm">ఆ ఇమెయిల్ నమోదై ఉంటే, పాస్‌వర్డ్ రీసెట్ లింక్ పంపాము. మీ Inbox (లేదా Spam) చూడండి. లింక్ 1 గంట మాత్రమే పనిచేస్తుంది.</p>
          </div>
        ) : (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground text-center">మీ ఖాతా ఇమెయిల్ ఇవ్వండి, రీసెట్ లింక్ పంపుతాము.</p>
            <div><Label className="text-maroon">ఇమెయిల్</Label>
              <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} className="gold-border" /></div>
            <Button data-testid="forgot-submit" onClick={submit} disabled={busy} className="w-full btn-sacred border-0">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "రీసెట్ లింక్ పంపండి"}</Button>
          </div>
        )}
        <p className="text-center text-sm mt-4"><Link to="/auth?mode=login" data-testid="forgot-back-login" className="text-saffron underline">లాగిన్‌కు వెనుకకు</Link></p>
      </div>
    </div>
  );
}
